export default {
    // Add to your translation files (create src/i18n/locales/en/birth-chart.js)

// Header Section
"birth_chart_generator": "Birth Chart Generator",
"create_your": "Create Your",
"birth_chart": "Birth Chart",
"kundli_analysis": "& Kundli Analysis",
"birth_chart_description": "Generate your personalized Vedic birth chart with detailed planetary positions, predictions, and remedial solutions based on your exact birth details.",

// Form Fields
"enter_birth_details": "Enter Your Birth Details",
"full_name": "Full Name",
"enter_full_name": "Enter your full name",
"gender": "Gender",
"male": "Male",
"female": "Female", 
"other": "Other",
"date_of_birth": "Date of Birth",
"time_of_birth": "Time of Birth",
"exact_time_note": "Exact birth time is crucial for accurate predictions",
"place_of_birth": "Place of Birth",
"place_of_birth_placeholder": "City, State, Country",
"place_birth_note": "Enter complete birth location for precise calculations",

// Chart Options
"chart_type": "Chart Type",
"south_indian_style": "South Indian Style",
"north_indian_style": "North Indian Style", 
"east_indian_style": "East Indian Style",

// Actions
"generate_birth_chart": "Generate Birth Chart",
"generating_chart": "Generating Chart",
"download_chart": "Download Chart",
"view_detailed_report": "View Detailed Report",

// Features
"what_you_get": "What You Get",
"detailed_planetary_positions": "Detailed Planetary Positions",
"zodiac_sign_analysis": "Zodiac Sign Analysis",
"dasha_system_predictions": "Dasha System Predictions", 
"remedial_suggestions": "Remedial Suggestions",

// Visual Elements
"sample_birth_chart": "Sample Birth Chart",
"sample_chart_description": "This is how your personalized birth chart will look",
"astrological_elements": "Astrological Elements",

// Planets
"sun": "Sun",
"moon": "Moon",
"mars": "Mars",
"mercury": "Mercury",
"jupiter": "Jupiter",
"venus": "Venus",

// Results
"your_birth_chart": "Your Birth Chart",
"chart_generated_successfully": "Chart Generated Successfully!",
"chart_ready_message": "Your personalized birth chart is ready with detailed analysis and predictions."

}